import { Trans } from 'react-i18next'
import { useSelector } from 'react-redux'

import ourGoalsEsPNG from '~/assets/images/history/history-our-goals-es.png'
import ourGoalsEsWEBP from '~/assets/images/history/history-our-goals-es.webp'
import ourGoalsPtPNG from '~/assets/images/history/history-our-goals-pt.png'
import ourGoalsPtWEBP from '~/assets/images/history/history-our-goals-pt.webp'
import ourGoalsPNG from '~/assets/images/history/history-our-goals.png'
import ourGoalsWEBP from '~/assets/images/history/history-our-goals.webp'
import { HistoryInfoPageStyles as S } from '~/pages/history/libs/infoPageStyles'
import { useNextStep } from '~/shared/hooks/useNextStep'
import { selectLanguage } from '~/shared/store/common/selects'
import { TPageProps } from '~/shared/types/commonTypes'

const LOCALE_IMAGE_MAP: Record<string, { png: string; webp: string }> = {
  es: { png: ourGoalsEsPNG, webp: ourGoalsEsWEBP },
  pt: { png: ourGoalsPtPNG, webp: ourGoalsPtWEBP },
  en: { png: ourGoalsPNG, webp: ourGoalsWEBP },
}

const OurGoals = ({ nextPagePath, pageId }: TPageProps) => {
  const lang = useSelector(selectLanguage)
  const { png, webp } = LOCALE_IMAGE_MAP[lang] ?? LOCALE_IMAGE_MAP.en

  const handleContinue = useNextStep({
    nextPagePath,
    pageId,
    pageName: pageId,
    question: 'Our goal is to help you achieve yours',
  })

  return (
    <S.Root>
      <S.StyledContainer>
        <S.ImageWrapper>
          <picture>
            <source srcSet={webp} type="image/webp" />
            <img src={png} alt="Learn, Practice, Implement" />
          </picture>
        </S.ImageWrapper>

        <S.Title>
          <Trans ns="history" i18nKey="onboarding.historyOurGoals.title" />
        </S.Title>

        <S.Subtitle>
          <Trans ns="history" i18nKey="onboarding.historyOurGoals.subtitle" />
        </S.Subtitle>

        <S.StyledButton type="button" onClick={() => handleContinue('')}>
          <Trans i18nKey="actions.continue" />
        </S.StyledButton>
      </S.StyledContainer>
    </S.Root>
  )
}

export default OurGoals
